<template>
  <div class="mso-discount-rules responsive-menu">
    <div class="responsive-menu__child">
      <PageHeader
        :pageHeader="listPageHeader"
        :links="[
          { name: 'home', label: 'Home' },
          { name: 'msoDiscountRules', label: 'MSO Discount Rules' },
        ]"
        :entity="entity"
      >
        <BaseBtn
          v-if="currentStore._id"
          label="Discount Settings"
          iconGroup="fas"
          iconName="cog"
          :colorType="6"
          @click="goToStoreSettings"
        />
      </PageHeader>
      <SearchTable
        :entity="entity"
        :sort="sort"
        @sortChangeEvent="updateSort"
        :pagination="pagination"
        @paginationChange="updatePagination"
        @initialFilterUpdate="updateInitialFilter"
        :initialFilter="initialFilter"
        :filterButtons="filterButtons"
        @filterButtonsChange="updateFilterButtons"
      />
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue";
import { listPageHeader } from "./inputs";
import SearchTable from "@/components/SearchTable.vue";
import Entities from "@/resources/Entities";
import { mapActions, mapGetters } from "vuex";
import BaseBtn from "@/components/Base/Button/Button.vue";

export default {
  name: "msoDiscountRules",
  data() {
    return {
      listPageHeader,
      entity: Entities.MSODISCOUNTRULE,
    };
  },
  mounted: function () {
    this.setPageTitle("MSO Discount Rules");
  },
  components: {
    PageHeader,
    SearchTable,
    BaseBtn,
  },
  computed: {
    ...mapGetters({
      sort: "msoDiscountRuleModule/sort",
      pagination: "msoDiscountRuleModule/pagination",
      initialFilter: "msoDiscountRuleModule/initialFilter",
      currentStore: "storeModule/currentStore",
      filterButtons: "msoDiscountRuleModule/filterButtons",
    }),
  },
  methods: {
    ...mapActions({
      updateSort: "msoDiscountRuleModule/updateSort",
      updatePagination: "msoDiscountRuleModule/updatePagination",
      updateInitialFilter: "msoDiscountRuleModule/updateInitialFilter",
      updateFilterButtons: "msoDiscountRuleModule/updateFilterButtons",
    }),
    goToStoreSettings() {
      this.$router.push({
        name: 'storeEditor',
        query: {
          id: this.currentStore._id,
          section: 'discountEngine'
        }
      });
    },
  }
};
</script>

